import { noop } from "@sail/utils";
/**
 * Transforms a promise into a stateful promise by adding a status property and value/reason.
 * This allows synchronously checking a promise's state, which isn't possible with regular promises.
 *
 * Augmented promises are valid thenables (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables)
 * React implementation (https://github.com/facebook/react/blob/97cdd5d3c33eda77be4f96a43f72d6916d3badbb/packages/shared/ReactTypes.js#L112-L138)
 * and react-query (https://github.com/TanStack/query/blob/35d5d55aa72a9e39284554852983b0745deecc52/packages/query-core/src/thenable.ts)
 */ export function transformToStatefulPromise(promise) {
    if ('status' in promise) {
        return promise;
    }
    const statefulPromise = Object.assign(promise, {
        status: 'pending'
    });
    statefulPromise.then((value)=>{
        Object.assign(statefulPromise, {
            status: 'fulfilled',
            value
        });
    }, (reason)=>{
        Object.assign(statefulPromise, {
            status: 'rejected',
            reason
        });
    });
    return statefulPromise;
}
export function createStatefulPromiseResolvers() {
    let resolver = noop;
    let rejector = noop;
    const promise = new Promise((resolve, reject)=>{
        resolver = resolve;
        rejector = reject;
    });
    const statefulPromise = transformToStatefulPromise(promise);
    if (statefulPromise.status === 'pending') {
        return Object.assign(statefulPromise, {
            resolve: resolver,
            reject: rejector
        });
    }
    return statefulPromise;
}

//# sourceMappingURL=statefulPromise.js.map